module.exports = __webpack_public_path__ + "static/media/infusions.dd39a6ed.svg";